import { Component, inject } from '@angular/core';
import { MatDialogRef, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { imageAssets } from '@core/constants/themes';
import { NewSaleDialogComponent } from '@sales/components/new-sale-dialog/new-sale-dialog.component';
import { IceButtonComponent } from '@app/shared/components/atoms/ice-button/ice-button.component';
import { CdkScrollable } from '@angular/cdk/scrolling';

@Component({
  selector: 'app-imei-info-dialog',
  templateUrl: './imei-info-dialog.component.html',
  styleUrls: ['./imei-info-dialog.component.scss'],
  imports: [CdkScrollable, MatDialogContent, MatDialogActions, IceButtonComponent],
})
export class ImeiInfoDialogComponent {
  dialogRef = inject<MatDialogRef<NewSaleDialogComponent>>(MatDialogRef);

  imageAssets = imageAssets;
}
